import { render, staticRenderFns } from "./PaypalPayment.vue?vue&type=template&id=6362fdb5&scoped=true&"
import script from "./PaypalPayment.vue?vue&type=script&lang=js&"
export * from "./PaypalPayment.vue?vue&type=script&lang=js&"
import style0 from "./PaypalPayment.vue?vue&type=style&index=0&id=6362fdb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362fdb5",
  null
  
)

export default component.exports